import React, { useState,useEffect } from 'react';
import style from "./VrtSession.module.sass";

const SelectButtonRelax = ({ presetRelax,scenery,titlePreset, sessionParameters,onSelect, onSelectValuesChange,onScenarioChange}) => {  
  const [selectedId, setSelectedId] = useState(null);
  const [selectValues, setSelectValues] = useState({
    code: '',
    time_day: '',
    weather: '',
    sounds: '',
    interactions_colors: '',
    interactions_objects: '',
    interactions_video_feedbacks: '',
    interactions_audio_feedbacks: '',
    image_url: ''
  });

  const [options, setOptions] = useState({
    time_day: [],
    weather: [],
    sounds: [],
    interactions_colors: [],
    interactions_objects: [],
    interactions_video_feedbacks: [],
    interactions_audio_feedbacks: []
  });

  useEffect(() => {

    if (sessionParameters) {
      setSelectedId(sessionParameters.selected_preset_id || null);
  
      let sceneryOptions = scenery.find(s => s.code === sessionParameters.scenery);
      
      if (sceneryOptions) {
        setSelectValues({
          code: sessionParameters.scenery || "",
          time_day: sceneryOptions.time_dayOptions?.includes(sessionParameters.time_day) ? sessionParameters.time_day : '',
          weather: sceneryOptions.weatherOptions?.includes(sessionParameters.weather) ? sessionParameters.weather : '',
          sounds: sceneryOptions.soundsOptions?.includes(sessionParameters.sounds) ? sessionParameters.sounds : '',
          interactions_colors: sceneryOptions.interactions_colorsOptions?.includes(sessionParameters.interactions_colors) ? sessionParameters.interactions_colors : '',
          interactions_objects: sceneryOptions.interactions_objectsOptions?.includes(sessionParameters.interactions_objects) ? sessionParameters.interactions_objects : '',
          interactions_video_feedbacks: sceneryOptions.interactions_video_feedbacksOptions?.includes(sessionParameters.interactions_video_feedbacks) ? sessionParameters.interactions_video_feedbacks : '',
          interactions_audio_feedbacks: sceneryOptions.interactions_audio_feedbacksOptions?.includes(sessionParameters.interactions_audio_feedbacks) ? sessionParameters.interactions_audio_feedbacks : '',
          image_url: sessionParameters.image_url
        });
  
        setOptions({    
          time_day: sceneryOptions.time_dayOptions || [],
          weather: sceneryOptions.weatherOptions || [],
          sounds: sceneryOptions.soundsOptions || [],
          interactions_colors: sceneryOptions.interactions_colorsOptions || [],
          interactions_objects: sceneryOptions.interactions_objectsOptions || [],
          interactions_video_feedbacks: sceneryOptions.interactions_video_feedbacksOptions || [],
          interactions_audio_feedbacks: sceneryOptions.interactions_audio_feedbacksOptions || []
        });
      }
    } else if (presetRelax && presetRelax.length > 0) {
      const firstId = presetRelax[0].id;
      setSelectedId(firstId);
      onSelect(firstId);
      updateSelectFields(firstId);
    }
  }, [sessionParameters, presetRelax, scenery, onSelect]);
  

  const handleButtonClick = (e, id) => {
    e.preventDefault();
    setSelectedId(id);
    onSelect(id);
    // Esegui l'azione desiderata quando viene cliccato un bottone
    console.log('Selected ID:', id);
    // Puoi anche inviare una richiesta al server o aggiornare lo stato dell'applicazione
    updateSelectFields(id);
  };

  const updateSelectFields = (id) => {
    const selectedPreset = presetRelax.find(preset => preset.id === id);
    if (selectedPreset) {
      console.log('Selected Preset:', selectedPreset);
      console.log('Selected Preset Code:', selectedPreset.code);
      console.log('Selected interaction:', selectedPreset.interactions_colorsOptions);
      const selectedCode = selectedPreset.code || '';
      const newSelectValues = {
        code: selectedCode,
        time_day: selectedPreset.time_dayOptions || '',
        weather: selectedPreset.weatherOptions || '',
        sounds: selectedPreset.soundsOptions || '',
        interactions_colors: selectedPreset.interactions_colorsOptions || [],
        interactions_objects: selectedPreset.interactions_objectsOptions || [],
        interactions_video_feedbacks: selectedPreset.interactions_video_feedbacksOptions || [],
        interactions_audio_feedbacks: selectedPreset.interactions_audio_feedbacksOptions || [],
        image_url: selectedPreset.image_url || 'pippo'
      };
      
      setSelectValues(newSelectValues);
      onSelectValuesChange(newSelectValues);
      updateOptions(selectedCode);
    }
  };

 

  const updateOptions = (code) => {
    const sceneryOptions = scenery.find(s => s.code === code);
    if (sceneryOptions) {

      setOptions({    
        time_day: sceneryOptions.time_dayOptions || [],
        weather: sceneryOptions.weatherOptions || [],
        sounds: sceneryOptions.soundsOptions || [],
        interactions_colors: sceneryOptions.interactions_colorsOptions || [],
        interactions_objects: sceneryOptions.interactions_objectsOptions || [],
        interactions_video_feedbacks: sceneryOptions.interactions_video_feedbacksOptions || [],
        interactions_audio_feedbacks: sceneryOptions.interactions_audio_feedbacksOptions || [],
        image_url: sceneryOptions.image_url
      });
      // Reset dei campi che non sono disponibili nel nuovo scenario
      setSelectValues(prevValues => ({
        ...prevValues,
        time_day: sceneryOptions.time_dayOptions?.length>0 ? prevValues.time_day : '',
        weather: sceneryOptions.weatherOptions?.length>0 ? prevValues.weather : '',
        sounds: sceneryOptions.soundsOptions?.length>0 ? prevValues.sounds : '',
        interactions_colors: sceneryOptions.interactions_colorsOptions ? prevValues.interactions_colors : [],
        interactions_objects: sceneryOptions.interactions_objectsOptions ? prevValues.interactions_objects : [],
        interactions_video_feedbacks: sceneryOptions.interactions_video_feedbacksOptions ? prevValues.interactions_video_feedbacks : [],
        interactions_audio_feedbacks: sceneryOptions.interactions_audio_feedbacksOptions ? prevValues.interactions_audio_feedbacks : [],
        image_url: sceneryOptions.image_url
    }));


    }
  };

  const updateOptionCode = (code) => {
    const sceneryOptions = scenery.find(s => s.code === code);
    if (sceneryOptions) {

      const newOptions = {    
        time_day: sceneryOptions.time_dayOptions || [],
        weather: sceneryOptions.weatherOptions || [],
        sounds: sceneryOptions.soundsOptions || [],
        interactions_colors: sceneryOptions.interactions_colorsOptions || [],
        interactions_objects: sceneryOptions.interactions_objectsOptions || [],
        interactions_video_feedbacks: sceneryOptions.interactions_video_feedbacksOptions || [],
        interactions_audio_feedbacks: sceneryOptions.interactions_audio_feedbacksOptions || [],
        image_url: sceneryOptions.image_url
      };

      setOptions(newOptions);
    // Imposta i valori predefiniti, prendendo il primo valore disponibile se presente
    const newSelectValues = {
      code,
      image_url: newOptions.image_url,
      time_day: newOptions.time_day.length > 0 ? newOptions.time_day[0] : '',
      weather: newOptions.weather.length > 0 ? newOptions.weather[0] : '',
      sounds: newOptions.sounds.length > 0 ? newOptions.sounds[0] : '',
      interactions_colors: newOptions.interactions_colors.length > 0 ? newOptions.interactions_colors[0] : [],
      interactions_objects: newOptions.interactions_objects.length > 0 ? newOptions.interactions_objects[0] : [],
      interactions_video_feedbacks: newOptions.interactions_video_feedbacks.length > 0 ? newOptions.interactions_video_feedbacks[0] : [],
      interactions_audio_feedbacks: newOptions.interactions_audio_feedbacks.length > 0 ? newOptions.interactions_audio_feedbacks[0] : []
    };

    setSelectValues(newSelectValues);
    onSelectValuesChange(newSelectValues);

    }
  };

  const handleSelectChange = (e, selectName) => {
    const value = e.target.value;
    let newSelectValues = {
      ...selectValues,
      [selectName]: value
    };
    


    setSelectValues(newSelectValues);
    onSelectValuesChange(newSelectValues);

    if (selectName === 'code') {
      if (value !== selectValues.code && typeof onScenarioChange === 'function') {
        onScenarioChange(); // notifica che lo scenario è stato cambiato
      }
      updateOptionCode(value);
    }
  };

  return (
    <div className={style.formGroup}>
     
      <label> Scenario </label>

        <select className={style.dropdown} value={selectValues.code} onChange={(e) => handleSelectChange(e, 'code')}>
          {scenery.map(s => (
            <option key={s.code} value={s.code}>
              {s.code}
            </option>
          ))}
        </select>
   

       {(options.time_day.length > 0 || selectValues.time_day)  && <label>Condizioni di luce</label>}
   
        {(options.time_day.length > 0 || selectValues.time_day) && (
          <select className={style.dropdown} value={selectValues.time_day} onChange={(e) => handleSelectChange(e, 'time_day')}>
            {options.time_day.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        )}



       { (options.weather.length > 0 || selectValues.weather)  && <label>Clima</label>}

        {(options.weather.length > 0 || selectValues.weather) && (
          <select  className={style.dropdown} value={selectValues.weather} onChange={(e) => handleSelectChange(e, 'weather')}>
            {options.weather.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        )}
 


       {(options.sounds.length > 0 || selectValues.sounds) && <label>Suoni ambientali e musica</label>}

        {(options.sounds.length > 0 || selectValues.sounds) && (
          <select  className={style.dropdown} value={selectValues.sounds} onChange={(e) => handleSelectChange(e, 'sounds')}>
            {options.sounds.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        )}
 


      {/* Nuove Select Box per le Interazioni */}
      {options.interactions_colors.length > 0 && <label>Interazioni con il colore</label>}

        {options.interactions_colors.length > 0 && (
          <select  className={style.dropdown} value={selectValues.interactions_colors} onChange={(e) => handleSelectChange(e, 'interactions_colors')}>

            {options.interactions_colors.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        )}
 


       {options.interactions_objects.length > 0 && <label>Interazioni di raccolta e movimento oggetti</label>}

        {options.interactions_objects.length > 0 && (
          <select  className={style.dropdown} value={selectValues.interactions_objects} onChange={(e) => handleSelectChange(e, 'interactions_objects')}>

            {options.interactions_objects.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        )}



       {options.interactions_video_feedbacks.length > 0 && <label>Interazioni con feedback visivi</label>}

        {options.interactions_video_feedbacks.length > 0 && (
          <select className={style.dropdown} value={selectValues.interactions_video_feedbacks} onChange={(e) => handleSelectChange(e, 'interactions_video_feedbacks')}>

            {options.interactions_video_feedbacks.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        )}
    


      {options.interactions_audio_feedbacks.length > 0 && <label>Interazioni con feedback audio</label>}

        {options.interactions_audio_feedbacks.length > 0 && (
          <select className={style.dropdown} value={selectValues.interactions_audio_feedbacks} onChange={(e) => handleSelectChange(e, 'interactions_audio_feedbacks')}>

            {options.interactions_audio_feedbacks.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </select>
        )}


    </div>


  
  );
};

export default SelectButtonRelax;
